/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import {
  Button,
  FormGroup,
  TextInput,
  Loading,
  AccordionItem,
  Accordion,
  ComboBox,
  DropdownSkeleton, MultiSelect
} from 'carbon-components-react';
import Close16 from '@carbon/icons-react/lib/close/16';
import PropTypes from 'prop-types';
import { Information16 } from '@carbon/icons-react';
import moment from 'moment';
import { api, me, drill } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  STATUS,
  PlannedWeekChangeType
} from '../../helpers/Constants';
import { IsEditable, IsInRole } from '../../helpers/authorization/Policies';
import { HistoryTable } from '../../helpers/HistoryTable';
import WeekSelector from '../../helpers/WeekSelector';
import Combo from '../common/Combo';
import '../../scss/emailchips.scss';
import EmailChips from '../../helpers/EmailChips';
import MeRepository from '../../helpers/api/MeRepository';


export default class EDrillDetails extends Component {
  currentDate = moment().format('YYYY-MM-DD');

  constructor(props) {
    super(props);
    this.onSelectDistributionListChange = this.onSelectDistributionListChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.saveEDrill = this.saveEDrill.bind(this);
    this.updateEDrill = this.updateEDrill.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    this.validator = new SimpleReactValidator({
      validators: {
        emails: {
          // name the rule
          message: 'The :attribute must be a valid email address list semicolon separated',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              // eslint-disable-next-line no-useless-escape
              /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
            ) && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });

    this.defaultGuid = null; // "00000000-0000-0000-0000-000000000000";
    this.weeks = [...Array(53).keys()].map((x) => x + 1).map(String);

    this.statuses = STATUS;
    this.state = {
      newEDrill: {
        id: this.props.EDrill?.id || uuid(),
        drillCode: this.props.EDrill?.drillCode || '',
        newDrillTypeDetail: this.props.EDrill?.newDrillTypeDetail,
        plannedWeek: this.props.EDrill?.plannedWeek || '',
        drillPlannedWeeks: this.props.EDrill?.drillPlannedWeeks || [],
        division: this.props.EDrill?.division || null,
        company: this.props.EDrill?.company || null,
        participant: this.props.EDrill?.participant || null,
        status: this.props.EDrill?.status || null,
        projects: this.props.EDrill?.projects || [],
        drillProjects: this.props.EDrill?.drillProjects || null,
        workSite: this.props.EDrill?.workSite || null,
        drillType: this.props.EDrill?.drillType || null,
        drillTypeDetail: this.props.EDrill?.drillTypeDetail || null,
        frequency: this.props.EDrill?.frequency || null,
        drillEmergencyLevel: this.props.EDrill?.drillEmergencyLevel || null,
        distributionList: this.props.EDrill?.distributionList || null,
        plannedYear: this.props.EDrill?.plannedYear || null,

        idDivision: this.props.EDrill?.workSite?.idDivision || this.defaultGuid,
        idParticipant: this.props.EDrill?.idParticipant || this.defaultGuid,
        idCompany: this.props.EDrill?.idCompany || this.defaultGuid,
        idStatus: this.props.EDrill?.idStatus || 0,
        idWorkSite: this.props.EDrill?.idWorkSite || this.defaultGuid,
        idDrillType: this.props.EDrill?.drillType?.id || this.defaultGuid,
        idDrillTypeDetail: this.props.EDrill?.idDrillTypeDetail || this.defaultGuid,
        idFrequency: this.props.EDrill?.idFrequency || this.defaultGuid,
        idEmergencyLevel: this.props.EDrill?.idEmergencyLevel || this.defaultGuid,
        newEmergLevManagement: this.props.EDrill?.newEmergLevManagement == null ? 
          true : this.props.EDrill?.newEmergLevManagement,
        isHistoryModalOpen: false,
      },
      divisions: [],
      appAllDrillTypeDT: [],
      appAllDrillType: [],
      appAllWorksites: null,
      appAllWorksitePrj: null,
      appAllEmergencyLevel: [],
      isLoadingDrillTypeDT: null,
      isSubmitted: false,
      isLoadingDivision: false,
      isLoadingWorksite: false,
      isLoadingProject: false,
      isLoadingEmergencyLevel: false,
      deletedPlannedWeek: [],
      addedPlannedWeek: [],
      updatedPlannedWeek: [],
      editingDisabled: this.props.EDrill
        ? !IsEditable(
            'Emergency Drill',
            'Planning',
            this.props.user,
            this.props.EDrill.status.id,
            'All',
            this.props.EDrill
          )
        : false,
      editingPlannedDisabled: this.props.EDrill
        ? ((!((this.props.EDrill.status.id === 4) && (IsInRole(this.props.user, 'Administrator') || IsInRole(this.props.user, 'Compiler')))
          ) || (this.props.EDrill.drillModifiedPlannedWeekSets && 
                this.props.EDrill.drillModifiedPlannedWeekSets.length > 0))
        : true
    };
    
    const year = new Date().getFullYear();
    this.years = Array.from(new Array(5), (val, index) => (index + year).toString());
  }

  componentDidMount() {
    this.getAllDivision();
    this.getAllWorkSite();
    this.getAllProjects();
    this.getAllDrillType();
    this.getAllDrillTypeDT();
    this.getAllEmergencyLevel();
  }

  getAllDivision = () => {
    this.setState({
      isLoadingDivision: true,
    });
    MeRepository.getDivisions()
      .then((response) => {
        this.setState({
          divisions: response,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DIVISION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingDivision: false,
        });
      });
  };

  getAllWorkSite = () => {
    this.setState({
      isLoadingWorksite: true,
    });
    me.getAll('worksites')
      .then((response) => {
        this.setState({
          appAllWorksites: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingWorksite: false,
        });
      });
  };

  getAllProjects = () => {
    this.setState({
      isLoadingProject: true,
    });
    api
      .getAll('/me/worksitesproject')
      .then((response) => {
        this.setState({
          appAllWorksitePrj: response.data.filter((a) => a.end >= this.currentDate),
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingProject: false,
        });
      });
  };

  getAllDrillType = () => {
    drill
      .get('drilltype')
      .then((response) => {
        this.setState({
          appAllDrillType: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
      });
  };

  getAllDrillTypeDT = () => {
    this.setState({
      isLoadingDrillTypeDT: true,
    });
    drill.get('drilltype/drilltypedetails')
      .then((response) => {
        this.setState({
          appAllDrillTypeDT: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingDrillTypeDT: false,
        });
      });
  };

  getAllEmergencyLevel = () => {
    this.setState({
      isLoadingEmergencyLevel: true,
    });
    drill.get('emergencylevel')
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            appAllEmergencyLevel: response.data,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,
            getError('Unsuccessfully get', entitiesLabels.EMERGENCYLEVEL, apioperation.GET)
          );
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.EMERGENCYLEVEL, apioperation.GET)
          );
      })
      .finally(() => {
        this.setState({
          isLoadingEmergencyLevel: false,
        });
      });
  };

  getWorksiteFiltered(idDivision) {
    if (idDivision != null) {
      const data = (this.state.appAllWorksites || []).filter((el) => el.idDivision === idDivision);
      return data;
    }
    return this.state.appAllWorksites;
  }

  getWorksitePrjFiltered(idWorksite) {
    if (idWorksite != null) {
      const data = (this.state.appAllWorksitePrj || [])
        .filter((el) => el.idWorkSite === idWorksite);
      return data;
    }
    return this.state.appAllWorksitePrj;
  }

  getDrillTypeDetailFiltered(idDrillType) {
    if (idDrillType != null) {
      const data = (this.state.appAllDrillTypeDT || [])
        .filter((el) => el.idDrillType === idDrillType);
      return data;
    }
    return this.state.appAllWorksitePrj;
  }
 
  showButtonHistory = () => (
    <Button kind="ghost" renderIcon={Information16} onClick={() => this.openModalHistory()}>
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  getSelectedProjects = (listProject) => {
    const selectedProjects = listProject.filter((e) => this.state.newEDrill.projects
      .some((i) => e.idProject === i.id || e.idProject === i.idProject));
    return selectedProjects;
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  onSelectDistributionListChange = (e) => {
    const val = e;
    this.setState((prevState) => {
      const newEDrill = { ...prevState.newEDrill };
      newEDrill.distributionList = val;
      return { newEDrill };
    });
  };
 
  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  saveEDrill = async (item) => {
    try {
      this.setState({ isSubmitted: true });
      const itemtoSubmit = item;
      itemtoSubmit.id = uuid();
      const { data } = await api.post('/drill', itemtoSubmit);
      showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.POST));
      return data;
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.POST));
      return null;
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  updateEDrill = async (item) => {
    try {
      this.setState({ isSubmitted: true });
      await api.put('/drill', item);
      return showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
      return null;
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.state.editingPlannedDisabled) {
      this.props.onDrillPlannedUpdate(
        this.state.deletedPlannedWeek, 
        this.state.addedPlannedWeek, 
        this.state.updatedPlannedWeek);
      return;
    }

    if (this.validator.allValid()) { 
      const id = this.state.newEDrill?.id;
      const newEDrillDTO = {
        id: this.state.newEDrill?.id || uuid(),
        newDrillTypeDetail: this.state.newEDrill?.newDrillTypeDetail,
        plannedWeek: this.state.newEDrill?.plannedWeek,
        drillPlannedWeeks: this.state.newEDrill.drillPlannedWeeks || [],
        plannedYear: this.state.newEDrill?.plannedYear,
        // division: this.state.newEDrill?.division || null,
        company: this.state.newEDrill?.company || null,
        participant: this.state.newEDrill?.participant || null,
        projects: this.state.newEDrill.projects || [],
        drillProjects: this.state.newEDrill.projects.map((key) => (
                { IdDrill: id != null ? id : uuid(), 
                  IdProject: key.idProject ? key.idProject : key.id })),
        workSite: this.state.newEDrill?.workSite || null,
        drillType: this.state.newEDrill?.drillType || null,
        drillTypeDetail: this.state.newEDrill?.drillTypeDetail || null,
        frequency: this.state.newEDrill?.frequency || null,
        drillEmergencyLevel: this.state.newEDrill?.drillEmergencyLevel || null,
        status: this.state.newEDrill?.status || null,
        distributionList: this.state.newEDrill?.distributionList || null,
        idParticipant: this.state.newEDrill?.idParticipant || this.defaultGuid,
        idDivision: this.state.newEDrill?.idDivision || this.defaultGuid,
        idCompany: this.state.newEDrill?.idCompany || this.defaultGuid,
        idStatus: this.state.newEDrill?.idStatus || 0,
        idWorkSite: this.state.newEDrill?.idWorkSite || this.defaultGuid,
        idDrillType: this.state.newEDrill?.idDrillType || this.defaultGuid,
        idDrillTypeDetail: this.state.newEDrill?.idDrillTypeDetail || this.defaultGuid,
        idFrequency: this.state.newEDrill?.idFrequency || this.defaultGuid,
        idEmergencyLevel: this.state.newEDrill?.idEmergencyLevel || this.defaultGuid,
        newEmergLevManagement: this.state.newEDrill?.newEmergLevManagement || false
      };
      if (this.props.EDrill) {
        newEDrillDTO.updatedBy = this.props.user.email;
        newEDrillDTO.updatedOn = new Date();
        newEDrillDTO.idCheckList = this.props.EDrill.checkList?.Id;
        newEDrillDTO.checkList = this.props.EDrill.checkList || null;
        await this.updateEDrill(newEDrillDTO);
        newEDrillDTO.division = this.state.newEDrill?.division || null;
        newEDrillDTO.idDivision = this.state.newEDrill?.idDivision || this.defaultGuid;
        newEDrillDTO.drillCode = this.state.newEDrill?.drillCode || '';
        this.props.onUpdate(newEDrillDTO);
      } else {
        newEDrillDTO.createdBy = this.props.user.email;
        newEDrillDTO.createdOn = new Date();
        newEDrillDTO.updatedBy = this.props.user.email;
        newEDrillDTO.updatedOn = newEDrillDTO.createdOn;
        const newItem = await this.saveEDrill(newEDrillDTO);
        newEDrillDTO.division = this.state.newEDrill?.division || null;
        newEDrillDTO.idDivision = this.state.newEDrill?.idDivision || this.defaultGuid;
        newEDrillDTO.idStatus = 1;
        newEDrillDTO.status = {
          id: 1,
          caManagementName: 'Draft',
          carManagementName: 'Assigned',
          carSimplifiedName: 'Opened',
          name: 'Draft',
          planningName: 'Draft',
          reportingName: 'Opened',
        };
        newEDrillDTO.drillCode = '';
        if (newItem) this.props.onSave(newEDrillDTO);
      }
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
        ` ${entitiesLabels.EMERGENCYDRILL} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  render() {
    const listWorksite = this.state.newEDrill.idDivision
      ? this.getWorksiteFiltered(this.state.newEDrill.idDivision)
      : [];
    const listProject = this.state.newEDrill.idWorkSite
      ? this.getWorksitePrjFiltered(this.state.newEDrill.idWorkSite)
      : [];
      const listDrillTypeDetail = this.state.newEDrill.idDrillType
      ? this.getDrillTypeDetailFiltered(this.state.newEDrill.idDrillType)
      : [];
    const selectedItemCombo = { idDrillType: this.state.newEDrill.idDrillType ?
       (this.state.appAllDrillType || []).find((el) => el.id === this.state.newEDrill?.idDrillType)
      : [],
      idDrillTypeDetail: this.state.newEDrill.idDrillTypeDetail
      ? (listDrillTypeDetail || []).find((el) => el.id === this.state.newEDrill.idDrillTypeDetail)
      : [],
      idDivision: this.state.newEDrill.idDivision
        ? (this.state.divisions || []).find((el) => el.id === this.state.newEDrill?.idDivision)
        : [],
      idWorkSite: this.state.newEDrill.idWorkSite
        ? (listWorksite || []).find((el) => el.id === this.state.newEDrill.idWorkSite)
        : [],
      idProject: this.state.newEDrill.projects
        ? this.getSelectedProjects(listProject) || []
        : [], 
      idEmergencyLevel: this.state.newEDrill.idEmergencyLevel ?
        (this.state.appAllEmergencyLevel || [])
          .find((el) => el.id === this.state.newEDrill?.idEmergencyLevel) : [], };

    const validations = {
      // division: this.validator.message('division', this.state.newEDrill.division, 'required'), //RITM0945977
      division: this.validator.message('businessLine', this.state.newEDrill.division, 'required'),
      company: this.validator.message('company', this.state.newEDrill.company?.id, 'required'),
      workSite: this.validator.message('workSite', this.state.newEDrill.workSite?.id, 'required'),
      drillType: this.validator.message(
        'drillType',
        this.state.newEDrill.drillType?.id,
        'required'
      ),
      drillTypeDetail: this.validator.message(
        'drillTypeDetail',
        this.state.newEDrill.drillTypeDetail?.id,
        'required'
      ),
      newDrillTypeDetail: this.validator.message(
        'newDrillTypeDetail',
          this.state.newEDrill.drillTypeDetail?.name.toUpperCase() !== 'OTHER' || this.state.newEDrill.drillType?.name.toUpperCase() !== 'OTHER'
            ? true
          : this.state.newEDrill.newDrillTypeDetail, // RITM0731493
        'required'
      ),
      idEmergencyLevel: this.validator.message(
        'emergencyLevel',
          this.state.newEDrill.newEmergLevManagement
            ? this.state.newEDrill.idEmergencyLevel : true, 
        'required'
      ),
      plannedYear: this.validator.message(
        'plannedYear',
        this.state.newEDrill.plannedYear,
        'required'
      ),
      participant: this.validator.message(
        'participant',
        this.state.newEDrill.participant?.id,
        'required'
      ),
      drillPlannedWeek: this.validator.message(
        'drillPlannedWeeks',
        this.state.newEDrill.drillPlannedWeeks[0],
        'required'
      ),
    };
    return (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            {this.props.EDrill ? (
              <h3 className="bx--modal-header__heading">
                {`Edit Drill Plan: ${this.props.EDrill.drillCode}`}
              </h3>
            ) : (
              <h3 className="bx--modal-header__heading">New Drill Plan</h3>
            )}
            {this.props.EDrill ? this.showButtonHistory() : ''}
            {
              <HistoryTable
                entityId={this.state.newEDrill.id}
                isOpenModal={this.state.isHistoryModalOpen}
                onClose={() => this.closeModalHistory()}
              />
            }
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.props.onCancel}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Drill Type *">

                  {/* <Combo
                    url="drill/drilltype"
                    invalid={validations.drillType != null}
                    invalidText={validations.drillType}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.drillType = event.selectedItem || null;
                        newEDrill.idDrillType = newEDrill.drillType?.id;
                        newEDrill.drillTypeDetail = null;
                        newEDrill.idDrillTypeDetail = null;
                        if (newEDrill.drillType?.name == 'LCU') newEDrill.projects = [];
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.DRILLTYPE, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newEDrill.drillType}
                    disabled={this.state.editingDisabled}
                    entity={this.state.newEDrill.drillType?.id}
                    placeholder="Select"
                  /> */}
                  {this.state.isLoadingDivision ? (
                    <DropdownSkeleton />
                        ) : (
                          <ComboBox
                            key={`idDrillType${selectedItemCombo.idDrillType}`}
                            id="idDrillType"
                            placeholder="Select"
                            name="idDrillType"
                            alt="newEDrill"
                            onChange={(event) =>
                              this.setState((prevState) => {
                                const newEDrill = { ...prevState.newEDrill };
                                newEDrill.drillType = event.selectedItem || null;
                                newEDrill.idDrillType = newEDrill.drillType?.id;
                                newEDrill.drillTypeDetail = null;
                                newEDrill.idDrillTypeDetail = null;
                                if (newEDrill.drillType?.name === 'LCU') newEDrill.projects = [];
                                return { newEDrill };
                              })
                            }
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={
                              selectedItemCombo.idDrillType ? selectedItemCombo.idDrillType : {}
                            }
                            items={this.state.appAllDrillType}
                            disabled={
                              this.state.isDisabled ||
                              this.state?.divisions == null ||
                              this.state?.divisions?.length <= 0 ||
                              (this.state.isEditModal &&
                                !IsEditable(
                                  'Drill',
                                  'Planning',
                                  this.props.user,
                                  this.getStatusId(this.state.newEDrill.id),
                                  'All',
                                  this.getCanEditResource(this.state.newEDrill.id)
                                )) ||
                                this.state.editingDisabled
                            }
                            invalid={validations.division != null}
                          />
                          )}
                  {validations.drillType}
                </FormGroup>

                {this.state.newEDrill.drillType?.name === 'Other' ? (
                  <>
                    <FormGroup legendText="New Drill Type Detail *">
                      <TextInput
                        invalid={validations.newDrillTypeDetail != null}
                        invalidText={validations.newDrillTypeDetail}
                        id="newDrillTypeDetail"
                        name="newDrillTypeDetail"
                        // placeholder="Specify new drill type detail..."
                        value={this.state.newEDrill.newDrillTypeDetail}
                        onChange={(event) => {
                          const val = event.target.value;
                          this.setState((prevState) => {
                            const newEDrill = { ...prevState.newEDrill };
                            newEDrill.newDrillTypeDetail = val || null;
                            return { newEDrill };
                          });
                        }}
                        type="text"
                        disabled={this.state.editingDisabled}
                        placeholder="Input Drill Type Detail"
                      />
                    </FormGroup>
                  </>
                ) : null}
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Drill Type Detail *">
                  {/* <Combo
                    url={
                      this.state.newEDrill.drillType?.id
                        ? `drill/drilltype/${this.state.newEDrill.drillType?.id}/drilltypedetails`
                        : ''
                    }
                    invalid={validations.drillTypeDetail != null}
                    invalidText={validations.drillTypeDetail}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.drillTypeDetail = event.selectedItem || null;
                        newEDrill.idDrillTypeDetail = newEDrill.drillTypeDetail?.id;
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.DRILLTYPEDETAIL, apioperation.GET)
                      );
                    }}
                    key="this.state.newEDrill.drillType?.id"
                    initialSelectedItems={this.state.newEDrill.drillTypeDetail}
                    disabled={this.state.editingDisabled || this.state.newEDrill.drillType == null}
                    entity={this.state.newEDrill.drillTypeDetail?.id}
                    placeholder="Select"
                  /> */}
                  {this.state.isLoadingDrillTypeDT ? (
                    <DropdownSkeleton />
                        ) : (
                          <ComboBox
                            key={`idDrillTypeDetail${selectedItemCombo.idDrillTypeDetail}`}
                            id="idDrillTypeDetail"
                            placeholder="Select"
                            name="idDrillTypeDetail"
                            alt="newEDrill"
                            onChange={(event) =>
                              this.setState((prevState) => {
                                const newEDrill = { ...prevState.newEDrill };
                                newEDrill.drillTypeDetail = event.selectedItem || null;
                                newEDrill.idDrillTypeDetail = newEDrill.drillTypeDetail?.id;
                                return { newEDrill };
                              })
                            }
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={
                              selectedItemCombo.idDrillTypeDetail ? 
                                selectedItemCombo.idDrillTypeDetail : {}
                            }
                            items={listDrillTypeDetail}
                            disabled={
                              this.state.isDisabled ||
                              this.state?.divisions == null ||
                              this.state?.divisions?.length <= 0 ||
                              (this.state.isEditModal &&
                                !IsEditable(
                                  'Drill',
                                  'Planning',
                                  this.props.user,
                                  this.getStatusId(this.state.newEDrill.id),
                                  'All',
                                  this.getCanEditResource(this.state.newEDrill.id)
                                )) ||
                                this.state.editingDisabled
                            }
                            invalid={validations.division != null}
                          />
                          )}
                  {validations.drillTypeDetail}
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                {/* RITM0945977 */}
                {/* <FormGroup legendText="Division *"> */}
                <FormGroup legendText="Business Line *">
                  {/* <Combo
                    invalid={validations.division != null}
                    invalidText={validations.division}
                    url="me/divisions"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.division = event.selectedItem || null;
                        newEDrill.idDivision = newEDrill.division?.id;
                        newEDrill.workSite = null;
                        newEDrill.projects = [];
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.DIVISION, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newEDrill.division}
                    disabled={this.state.editingDisabled}
                    entity={this.state.newEDrill.division?.id}
                    placeholder="Select"
                  /> */}
                  {this.state.isLoadingDivision ? (
                    <DropdownSkeleton />
                        ) : (
                          <ComboBox
                            key={`idDivision_${selectedItemCombo.idDivision}`}
                            id="idDivision"
                            placeholder="Select"
                            name="idDivision"
                            alt="newEDrill"
                            onChange={(event) =>
                              this.setState((prevState) => {
                                const newEDrill = { ...prevState.newEDrill };
                                newEDrill.division = event.selectedItem || null;
                                newEDrill.idDivision = newEDrill.division?.id;
                                newEDrill.workSite = null;
                                newEDrill.projects = [];
                                return { newEDrill };
                              })}
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={
                              selectedItemCombo.idDivision ? selectedItemCombo.idDivision : {}
                            }
                            items={this.state.divisions}
                            disabled={
                              this.state.isDisabled ||
                              this.state?.divisions == null ||
                              this.state?.divisions?.length <= 0 ||
                              (this.state.isEditModal &&
                                !IsEditable(
                                  'Drill',
                                  'Planning',
                                  this.props.user,
                                  this.getStatusId(this.state.newEDrill.id),
                                  'All',
                                  this.getCanEditResource(this.state.newEDrill.id)
                                )) ||
                                this.state.editingDisabled
                            }
                            invalid={validations.division != null}
                          />
                          )}
                  {validations.division}
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Company *">
                  <Combo
                    invalid={validations.company != null}
                    invalidText={validations.company}
                    url="me/companies"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.company = event.selectedItem || null;
                        newEDrill.idCompany = newEDrill.company?.id;
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(`${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.COMPANY, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newEDrill.company}
                    disabled={this.state.editingDisabled}
                    entity={this.state.newEDrill.company?.id}
                    placeholder="Select"
                  />
                  {validations.company}
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Work Site *">
                  {/* <Combo
                    url={
                      this.state.newEDrill.idDivision
                        ? `me/division/${this.state.newEDrill.idDivision}/worksites`
                        : ''
                    }
                    invalid={validations.workSite != null}
                    invalidText={validations.workSite}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.workSite = event.selectedItem || null;
                        newEDrill.idWorkSite = newEDrill.workSite?.id;
                        newEDrill.projects = [];
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.WORKSITE, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newEDrill.workSite}
                    disabled={this.state.editingDisabled || this.state.newEDrill.division == null}
                    entity={this.state.newEDrill.workSite?.id}
                    placeholder="Select"
                  /> */}
                  {this.state.isLoadingWorksite ? (
                    <DropdownSkeleton />
                        ) : (
                          <ComboBox
                            id="idWorkSite"
                            key={`idWorkSite_${selectedItemCombo.idWorkSite}`}
                            placeholder="Select"
                            name="idWorkSite"
                            alt="newEDrill"
                            onChange={(event) =>
                              this.setState((prevState) => {
                                const newEDrill = { ...prevState.newEDrill };
                                newEDrill.workSite = event.selectedItem || null;
                                newEDrill.idWorkSite = newEDrill.workSite?.id;
                                newEDrill.projects = [];
                                return { newEDrill };
                              })}
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItem={selectedItemCombo.idWorkSite}
                            items={listWorksite}
                            disabled={
                              this.state.isDisabled ||
                              this.state.newEDrill.idDivision == null ||
                              listWorksite == null ||
                              listWorksite?.length <= 0 ||
                              (this.state.isEditModal &&
                                !IsEditable(
                                  'Drill',
                                  'Planning',
                                  this.props.user,
                                  this.getStatusId(this.state.newEDrill.id),
                                  'All',
                                  this.getCanEditResource(this.state.newEDrill.id)
                                )) ||
                                this.state.editingDisabled
                            }
                            invalid={validations?.worksite != null}
                          />
                        )}
                  {validations.workSite}
                </FormGroup>
              </div>
              <div id="drill-proj" className="bx--col-lg-6 bx--col-md-12">
                <FormGroup
                  legendText="Projects"
                >
                  {/* <Combo
                    invalid={validations.project != null}
                    invalidText={validations.project}
                    multiCombo={true}
                    id="this.state.newEDrill.workSite?.id"
                    key={this.state.newEDrill.workSite?.id}
                    url={
                      this.state.newEDrill.workSite?.id
                        ? `project/worksite/${this.state.newEDrill.workSite?.id}`
                        : ''
                    }
                    onChange={(prjs) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.projects = prjs || [];
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.projects, apioperation.GET)
                      );
                    }}
                    placeholder="Select"
                    initialSelectedItems={this.state.newEDrill.projects}
                    disabled={
                      this.state.editingDisabled ||
                      this.state.newEDrill.drillType?.name == 'LCU' ||
                      this.state.newEDrill.workSite == null
                    }
                  /> */}
                  {this.state.isLoadingProject ? (
                    <DropdownSkeleton />
                        ) : (
                          <MultiSelect
                            id="idProject"
                            key={`idProject_${selectedItemCombo.idProject}`}
                            placeholder="Select"
                            multiCombo
                            name="projects"
                            alt="newEDrill"
                            onChange={(prjs) =>
                              this.setState((prevState) => {
                                const newEDrill = { ...prevState.newEDrill };
                                newEDrill.projects = prjs.selectedItems || [];
                                return { newEDrill };
                              })
                          }
                            helperText="Note: the field is mandatory unless the project is not yet defined in this stage"
                            itemToString={(item) => (item ? item.project : '')}
                            initialSelectedItems={this.getSelectedProjects(listProject)}
                            items={listProject}
                            disabled={
                            this.state.newEDrill.idDivision == null ||
                            this.state.newEDrill.idWorkSite == null ||
                            listProject == null ||
                            listProject?.length <= 0 ||
                            (this.state.isEditModal &&
                              !IsEditable(
                                'Drill',
                                'Planning',
                                this.props.user,
                                this.getStatusId(this.state.newEDrill.id),
                                'All',
                                this.getCanEditResource(this.state.newEDrill.id)
                              )) ||
                              this.state.editingDisabled
                          }
                            invalid={validations.idProject != null}
                          />
                        )}
                  {this.state.editingDisabled ?
                    <p>{(this.state.newEDrill.projects.map((item) => item.name ? item.name : item.project).sort()).join(', ')}</p>
                      : null
                  }
                  {validations.project}
                </FormGroup>
              </div>
            </div>
            { this.state.newEDrill?.newEmergLevManagement ? (
              <div className="bx--row">
                <div className="bx--col-lg-6 bx--col-md-12">
                  <FormGroup legendText="Emergency Level *">
                    {this.state.isLoadingEmergencyLevel ? (
                      <DropdownSkeleton />) : (
                        <ComboBox
                          id="idEmergencyLevel"
                          key={`idEmergencyLevel_${selectedItemCombo.idEmergencyLevel}`}
                          placeholder="Select"
                          name="idEmergencyLevel"
                          alt="newEDrill"
                          onChange={(event) => 
                            this.setState((prevState) => {
                              const newEDrill = { ...prevState.newEDrill };
                              newEDrill.drillEmergencyLevel = event.selectedItem || null;
                              newEDrill.idEmergencyLevel = newEDrill.drillEmergencyLevel?.id;
                              return { newEDrill };
                            })
                          }
                          itemToString={(item) => (item ? item.name : '')}
                          initialSelectedItem={selectedItemCombo.idEmergencyLevel}
                          items={this.state.appAllEmergencyLevel}
                          disabled={
                            this.state.isDisabled ||
                            (this.state.isEditModal &&
                              !IsEditable(
                                'Drill',
                                'Planning',
                                this.props.user,
                                this.getStatusId(this.state.newEDrill.id),
                                'All',
                                this.getCanEditResource(this.state.newEDrill.id)
                              )) ||
                              this.state.editingDisabled
                          }
                          invalid={validations.idEmergencyLevel != null}
                        />
                      )
                    }
                    {validations.idEmergencyLevel}     
                  </FormGroup>
                </div>
              </div>) : ''}
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Participant *">
                  <Combo
                    url="drill/participant"
                    invalid={validations.participant != null}
                    invalidText={validations.participant}
                    initialSelectedItems={this.state.newEDrill.participant || null}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.participant = event.selectedItem || null;
                        newEDrill.idParticipant = newEDrill.participant?.id;
                        return { newEDrill };
                      })
                    }
                    disabled={this.state.editingDisabled}
                    placeholder="Select"
                  />
                  {validations.participant}
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Planned Year *">
                  <Combo
                    invalid={validations.plannedYear != null}
                    invalidText={validations.plannedYear}
                    items={this.years}
                    initialSelectedItems={this.state.newEDrill.plannedYear || null}
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.plannedYear = event.selectedItem || null;
                        return { newEDrill };
                      })
                    }
                    disabled={this.state.editingDisabled}
                    placeholder="Select"
                  />
                  {validations.plannedYear}
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Distribution List (Personal Email Addresses are not allowed)">
                  <EmailChips
                    id="inputDistributionList"
                    invalid={validations.distributionList != null}
                    value={this.state.newEDrill.distributionList || ''}
                    disabled={this.state.editingDisabled}
                    type="text"
                    title="&#9888; Do Not use Personal Accounts"
                    onChange={this.onSelectDistributionListChange}
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Frequency">
                  <Combo
                    invalid={validations.frequency != null}
                    invalidText={validations.frequency}
                    url="drill/frequency"
                    onChange={(event) =>
                      this.setState((prevState) => {
                        const newEDrill = { ...prevState.newEDrill };
                        newEDrill.frequency = event.selectedItem || null;
                        newEDrill.idFrequency = newEDrill.frequency?.id;
                        return { newEDrill };
                      })
                    }
                    onError={(error) => {
                      showNotification.error(`${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.FREQUENCY, apioperation.GET)
                      );
                    }}
                    initialSelectedItems={this.state.newEDrill.frequency}
                    disabled={this.state.editingDisabled}
                    entity={this.state.newEDrill.frequency?.id}
                    placeholder="Select"
                  />
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <Accordion>
                <AccordionItem open="true" title="Planned weeks">
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <WeekSelector
                      id="wsPlannedWeek"
                      invalid={validations.drillPlannedWeeks != null}
                      weeks={this.weeks}
                      initialWeeksSelected={[]}
                      items={this.state.newEDrill.drillPlannedWeeks}
                      year={(this.state.newEDrill.plannedYear != null && 
                            this.state.newEDrill.plannedYear !== undefined) ? 
                            Number(this.state.newEDrill.plannedYear) : null}
                      disabled={this.state.editingDisabled}
                      editingDisabled={this.state.editingPlannedDisabled}
                      type="text"
                      onChange={(plnW) =>
                        this.setState((prevState) => {
                          const newEDrill = { ...prevState.newEDrill };
                          newEDrill.drillPlannedWeeks = plnW || null;
                          return { newEDrill };
                        })
                      }
                      onSubmitPlannedWeekChange={(plnWeek) => {
                        if (plnWeek !== null) {
                          this.setState((prevState) => {
                            let prevWeek = [];
                            if (plnWeek.idDrillPlannedWeekChangeType ===
                                PlannedWeekChangeType.ToAdd) {
                              prevWeek = prevState.addedPlannedWeek;
                              prevWeek.push(plnWeek);
                              return { addedPlannedWeek: prevWeek };
                            } 
                            if (plnWeek.idDrillPlannedWeekChangeType ===
                                       PlannedWeekChangeType.ToChange) {
                              prevWeek = prevState.updatedPlannedWeek;
                              prevWeek.push(plnWeek);
                              return { updatedPlannedWeek: prevWeek };
                            } 
                            prevWeek = prevState.deletedPlannedWeek;
                            prevWeek.push(plnWeek);
                            return { deletedPlannedWeek: prevWeek };
                          });
                        }
                      }}
                    />
                  </div>
                  {validations.drillPlannedWeek}
                </AccordionItem>
              </Accordion>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button className="button--max-width" kind="secondary" onClick={this.props.onCancel}>
              Cancel
            </Button>

            <Button
              className="button--max-width"
              kind="primary"
              disabled={this.state.editingDisabled && this.state.editingPlannedDisabled}
              onClick={this.handleSubmit}
            >
              Save
            </Button>
          </div>
          {this.renderLoadingModal()}
        </div>
      </div>
    );
  }
}
EDrillDetails.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDrillPlannedUpdate: PropTypes.func.isRequired,
  EDrill: PropTypes.object,
  user: PropTypes.object.isRequired,
};
EDrillDetails.defaultProps = { EDrill: null };
